import { Link, useLocation } from "react-router-dom";
import { buttonVariants } from "@/components/ui/button";
import { FullPageError } from "@/components/ui/system-state";
import { useAuthStore } from "@/stores/auth-store";

/**
 * The SPA 404 (ONB-109, UX audit D12/D17): a route miss must offer the next
 * step, not just name the problem. The page shows the pathname the visitor
 * actually reached — pathname only, never the query string, because a search or
 * an invite link can carry a token that must not be echoed back — plus a way
 * home for everyone and the wallet list for a session that has one.
 */
export default function RouteNotFoundPage() {
  const { pathname } = useLocation();
  const signedIn = useAuthStore((s) => s.user !== null);

  return (
    <main className="flex min-h-screen w-full items-center justify-center p-4 sm:p-6">
      <div className="w-full max-w-[640px]">
        <FullPageError
          code="404"
          codeTone="primary"
          title="This page does not exist"
          description="The page you requested does not exist or may have been moved. Check the address or return to a known location."
          homeHref="/home"
          homeLabel="Go to home"
          actions={
            // Only a signed-in visitor can use the wallet list; everyone else
            // gets the one destination that works without a session.
            signedIn ? (
              <Link to="/wallets" className={buttonVariants({ variant: "secondary", size: "md" })}>
                Go to wallets
              </Link>
            ) : undefined
          }
        />
        <p
          data-testid="route-not-found-path"
          className="mt-3 break-all text-center font-mono text-xs text-muted"
        >
          {pathname}
        </p>
      </div>
    </main>
  );
}
